/**
 * TanStack Router: /performance/guia
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceGuiaPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceGuiaPage from '@/app/performance/guia/page'

/**
 * Route: /performance/guia
 * Layout: _auth (authenticated)
 * Component: PerformanceGuiaPage
 */
export const Route = createFileRoute('/_auth/performance/guia')({
  component: PerformanceGuiaPage,
})
